module.exports = __webpack_public_path__ + "img/Kraven.16bca8cf.png";